import driverSlide1 from '../../assets/images/driver/driver-slide1.jpg';
import driverSlide2 from '../../assets/images/driver/driver-slide2.jpg';
import driverSlide3 from '../../assets/images/driver/driver-slide3.jpg';
import driverSlide4 from '../../assets/images/driver/driver-slide4.jpg';

const driverImages = [
  {
    src: driverSlide1,
    alt: "1",
    heading: "RC Medical",
    text: "A brand created in response for market needs, dictated by COVID-19 pandemic.",
    button: "",
    link: "",
  },
  {
    src: driverSlide2,
    alt: "2",
    heading: "Safety first",
    text: "Safety of our clients is our number one priority. We make the effort to ensure the best quality of our products.",
    button: "",
    link: "",
  },
  {
    src: driverSlide3,
    alt: "3",
    heading: "Satisfied clients",
    text: "With professional service and individual approach to a client, we guarantee success and long-term cooperation.",
    button: 'testimonials',
    link: "/testimonials",
  },
  {
    src: driverSlide4,
    alt: "4",
    heading: "Wide product range",
    text: "In response of our client's needs, we continuously widen our offer with new medical products.",
    button: "products",
    link: "/products",
  },
];

export { driverImages };